






















































import { Vue } from "vue-property-decorator";
import { stadium_ground } from "@/@types/stadium/ground"
import Grounds from "@/views/stadium_ground/stadium_grounds.vue"
import Ground from "@/views/invest/detail/form/add_stadium_ground.vue"

export default Vue.extend({
  name      : "StadiumGrounds",
  components: { Grounds, Ground },
  props     : {
    id        : { type: String, required: true },
    button    : { type: Boolean, default: true },
    editable  : { type: Boolean, required: true },
    stadium_id: { type: String, required: true },
    correct   : { type: Object, default() { return {} } },
    show      : { type: Boolean, default: true },
  },
  data() {
    return {
      data   : [] as stadium_ground[],
      origin : [] as stadium_ground[],
      change : [] as stadium_ground[],
      total  : 0,
      columns: [
        { dataIndex: "index", title: "序号", align: "center", width: 80, scopedSlots: { customRender: "index" } },
        { dataIndex: "name", title: "片场名称", align: "center", ellipsis: true, scopedSlots: { customRender: "name" } },
        { dataIndex: "status", title: "状态", align: "center", width: 120, scopedSlots: { customRender: "status" } },
        { title: "上移", align: "center", width: 120, scopedSlots: { customRender: "up" } },
        { title: "下移", align: "center", width: 120, scopedSlots: { customRender: "down" } },
      ],
      status: {
        0: { label: "下线", status: "error" },
        1: { label: "上线", status: "success" }
      },
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.list()
        /* this.show_grounds = true
        setTimeout(() => {
          this.show_grounds = false
        }, 10) */
      })
    },
    open_grounds() {
      this.$nextTick(() => {
        const grounds = this.$refs.grounds as any
        grounds.open()
      })
    },
    if_correct(index: number) {
      let is_correct = ""
      if (this.data.length > index) {
        const data = this.$deep_copy(this.data[index])
        if (this.origin.length > index) {
          const compare = this.$deep_copy(this.origin[index])
          for (const k in data) {
            if (Object.prototype.hasOwnProperty.call(data, k)) {
              if (data[k] != compare[k]) {
                is_correct = "is_correct"
                break
              } else is_correct = ""
            }
          }
        } else is_correct = "is_correct"
      } return is_correct
    },
    show_correct(): boolean {
      let change = false
      if (this.change.length == 0) return false
      const data = this.$deep_copy(this.data)
      const compare = this.$deep_copy(this.change)
      if (data.length != compare.length) return true
      for (const k in data) {
        if (Object.prototype.hasOwnProperty.call(data, k) && Object.prototype.hasOwnProperty.call(compare, k)) {
          for (const key in data[k]) {
            if (Object.prototype.hasOwnProperty.call(data[k], key)) {
              if (data[k][key] != compare[k][key]) {
                change = true
                break
              } change = false
            }
          }
        } else change = false
      }
      return change
    },
    async list() {
      this.$nextTick(async () => {
        const params = { stadium_id: this.stadium_id }
        const res = await this.$store.dispatch("stadium/getStadiumGrounds", params);
        if (res.Code == 200) {
          const data = this.$deep_copy(res.Data)
          this.data   = this.$deep_copy(data)
          this.origin = this.$deep_copy(data)
          this.total  = this.data.length
        }
      })
    },
    up(i: number) {
      const data = this.$deep_copy(this.data)
      const up   = this.$deep_copy(data[i])
      const down = this.$deep_copy(data[i - 1])
      up.sn       = data[i - 1].sn
      down.sn     = data[i].sn
      data[i - 1] = up
      data[i]     = down
      this.data   = data
    },
    down(i: number) {
      const data = this.$deep_copy(this.data)
      const down   = this.$deep_copy(data[i])
      const up = this.$deep_copy(data[i + 1])
      up.sn = data[i].sn
      down.sn = data[i + 1].sn
      data[i] = up
      data[i + 1] = down
      this.data = data
    },
    submit() {
      const list = [] as stadium_ground[]
      for (const o of this.origin) {
        for (const v of this.data) {
          if (v.id == o.id && v.sn != o.sn) {
            list.push(v)
          }
        }
      }
      for (const v of list) this.save(v)
    },
    async save(params: stadium_ground) {
      const res = await this.$store.dispatch("stadium/editGround", params);
      if (res.Code != 200) {
        this.$error({ content: res.Message })
      }
    },
    add_ground() {
      const ground = this.$refs.ground as any
      ground.open(0)
    },
    add(ground: stadium_ground) {
      this.data.push(ground)
      this.total = this.data.length
    },
    /* 提交纠错的内容 */
    modify() {
      const params = this.$deep_copy(this.data)
      params.estimate_id = this.id
      // 内容没有变化，则不提交
      if (JSON.stringify(this.origin) != JSON.stringify(params)) {
        this.$emit("modify", { grounds: JSON.stringify(params) })
      }
    },
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.modify()
          if (Object.prototype.hasOwnProperty.call(this.correct, "grounds")) this.change = JSON.parse(this.correct.grounds)
        })
      },
      deep: true
    }
  }
})

